import { Image as ElementImage } from 'element-ui'
import { imageFallbackSources } from '@/utils/resolveImage'

// 원본 URL이 바뀌면 이 경계 컴포넌트를 새로 만들어 이전 로딩 이벤트와 상태를 버린다.
const ImageAttempt = {
  inheritAttrs: false,
  props: { sources: Array, native: Boolean },
  data: () => ({ index: 0, failed: false }),
  render(h) {
    const index = this.index
    const src = this.sources[index] || ''
    const on = {
      ...this.$listeners,
      error: (event) => {
        if (this._isDestroyed || this.failed || this.index !== index) return
        if (index + 1 < this.sources.length) {
          this.index = index + 1
        } else {
          this.failed = true
          this.$emit('error', event)
        }
      },
    }
    if (this.native && (this.failed || !src)) {
      return h(
        'span',
        {
          attrs: { ...this.$attrs, role: 'img', 'aria-label': this.$t('이미지 없음') },
          style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f7fa',
            color: '#909399',
          },
          on: this.$listeners,
        },
        this.$scopedSlots.error ? this.$scopedSlots.error() : this.$slots.error || this.$t('이미지 없음')
      )
    }
    return h(
      this.native ? 'img' : ElementImage,
      {
        key: src,
        attrs: { ...this.$attrs, src },
        props: this.native ? {} : { ...this.$attrs, src },
        on,
        scopedSlots: this.$scopedSlots,
      },
      this.native ? undefined : Object.values(this.$slots).flat()
    )
  },
}

export default {
  name: 'FallbackImage',
  inheritAttrs: false,
  props: { src: String, native: Boolean },
  render(h) {
    const sources = imageFallbackSources(this.src)
    return h(
      ImageAttempt,
      {
        key: JSON.stringify(sources),
        props: { sources, native: this.native },
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots,
      },
      Object.values(this.$slots).flat()
    )
  },
}
